import lockBodyScroll from '../helpers/lockBodyScroll';
/**
 * Global Overlay Class
 */
export default class Overlay {
  /**
   * constructor
   */
  constructor() {
    this.config = {
      selector: {
        overlay: '[data-overlay]',
        overlayContent: '[data-overlay-content]',
        trigger: '[data-overlay-trigger]',
        closeBtn: '[data-overlay-close]',
      },
      modifier: {
        visible: 'overlay--visible',
      },
    };
    this.triggers = document.querySelectorAll(this.config.selector.trigger);
    this.overlay = document.querySelector(this.config.selector.overlay);
    this.overlayContent = this.overlay.querySelector(this.config.selector.overlayContent);
    if (!this.triggers.length) {
      return;
    }
    this.bindEvents();
  }

  /**
   * Delegate Events from document for trigger
   */
  bindEvents() {
    document.addEventListener('click', (event) => { this.handleClicks(event); });
  }

  /**
   * handles event delegation
   * @param {MouseEvent} event
   */
  handleClicks(event) {
    const { target } = event;
    const isTrigger = target.closest(this.config.selector.trigger);
    const isClose = target.closest(this.config.selector.closeBtn);
    if (isTrigger) { this.open(isTrigger); }
    if (isClose) { this.close(); }
  }

  /**
   * The data-overlay-trigger contains an JSON sting for further options:
   * content and cssClass.
   * Content is the Id selector where to find the fitting content for the trigger.
   * cssClass is the optional parameter to an an custom CSS-class to the overlay-content-container.
   * Locks body from scrolling and after inserting the content into the overlay add the modifier
   * class to make the overlay visible
   * @param {HTMLElement} trigger
   * */
  open(trigger) {
    this.scrollPosY = window.scrollY;
    lockBodyScroll(true);
    const config = JSON.parse(trigger.dataset.overlayTrigger);
    const content = document.getElementById(config.content).innerHTML;
    this.overlayContent.classList.add(config?.cssClass ?? '');
    this.overlayContent.innerHTML = content;
    this.overlay.classList.add(this.config.modifier.visible);
  }

  /**
   * unlocks body scroll lock and removes modifier to hide overlay
   */
  close() {
    lockBodyScroll(false, this.scrollPosY);
    this.overlay.classList.remove(this.config.modifier.visible);
  }
}
